<div class="container-fluid">
  <div class="row">
    <h3
      class="text-primary mb-0 h5"
      id="emailSubscriptionHeading"
    >
      Email Subscription
    </h3>
    <div class="col-md-8">
      <ul class="list-group list-group-flush mb-3">
        <li
          *ngFor="let subscription of subscriptions; let idx = index"
          class="list-group-item ps-0 pe-0 d-flex justify-content-between align-items-center"
        >
          <span tabindex="0" [id]="'emailLabel-' + idx">{{ subscription?.subDescription }}</span>
          <nr-toggle-switch
            [label]="subscription?.subDescription"
            [formControl]="getIsActiveControl(idx)"
            name="idx"
            (toggleChange)="onEmailSubscriptionChange()"
          ></nr-toggle-switch>
        </li>
      </ul>
    </div>
  </div>
</div>
